const MODULE_NAME = 'kapcsolatService';
import guid from '../../common/guid/guid';
class KapcsolatService {
	constructor($http, environment, $q) {
		'ngInject';
		this._$http = $http;
		this._$q = $q;
		this._environment = environment;
		this._apiRoot = $http({
			url: `${environment.backendUrl}/do/proxy/b`
		});
	}
	getSzolgaltatasok() {
		return this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$get('kapcsolatSzolgaltatasok', { page: 0, size: 9999 });
		}).then((resp) => {
			return resp.$hasEmbedded('kapcsolatSzolgaltatasok') ? resp.$request().$get('kapcsolatSzolgaltatasok') : [];
		}, () => {
			return this._$q.reject();
		});
	}
	getVarosokByIrszam(irszam) {
		return this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$get('telepulesIranyitoszamAlapjan', { iranyitoszam:irszam });
		}).then((resp) => {
			return resp.$hasEmbedded('iranyitoszamok') ? resp.$request().$get('iranyitoszamok') : [];
		}, () => {
			return this._$q.reject();
		}).then((resp) => {
			return resp.map((item)=>item.telepules);
		}, () => {
			return this._$q.reject();
		});
	}
	kuldes(model, captcha) {
		let headers = {
			'x-captcha-id': this._captchaId,
			'x-captcha-value': captcha
		};
		return this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$post('kapcsolatLetrehozas', null, model, { headers });
		}, () => {
			return this._$q.reject();
		});
	}
	getCaptchaUrl() {
		this._captchaId = guid();
		return `${this._environment.captchaUrl}/${this._captchaId}?appid=otpagrar`;
	}
}

export default angular.module(MODULE_NAME, []).service('kapcsolatService', KapcsolatService).name;



// WEBPACK FOOTER //
// ./source/applications/kapcsolat/kapcsolat-service.js